<template>
	<page>
		<module title="分销设置">
			<c-form ref="form">
				<c-form-item type="image" label="分销海报图" name="share_img_list" limit="5" required file-word="建议尺寸：600×1000像素，格式支持：jpg、png，最多上传5张"></c-form-item>

                <c-form-item type="number" decimal="2" :limit="[0.01,9999999]" label="超期自动转单时间"
                             name="auto_transfer_period" input-unit="天" word="经销商设置了【手动转单】后，从接单时间算起，超过该时间，则自动转单至上级；该配置适用所有订单，修改后立即生效"></c-form-item>

                <c-form title="进货补贴配置" v-show="false">
					<c-form-item type="number" label="进货补贴" :limit="[0,100]" required name="zt_pz_order_ratio" decimal="2" input-unit="%" word="会员购买供货类型产品，相同等级的上级可获得产品交易额对应比例的补贴"></c-form-item>
					<c-form-item type="number" label="辅助进货补贴" :limit="[0,100]" required name="jt_pz_order_ratio" decimal="2" input-unit="%" word="会员购买供货类型产品，相同等级的上上级可获得产品交易额对应比例的补贴"></c-form-item>
				</c-form>
				
				<c-form title="奖励配置">
					<c-form-item>
						<ul class="tab flex">
							<li v-for="(item, i) in levelList" :key="i" :class="{'z-crt': currentTab == i}" @click="currentTab = i">{{item.level_name}}</li>
						</ul>
						<div v-for="(item, i) in levelList" :key="i" v-show="currentTab == i" class="tab-content">
							<c-form style="padding: 30px 24px;">
								<c-form title="销售佣金设置">
									<c-form-item v-if="item.id == 1" type="number" decimal="2" style="width:800px" label="直推会员下单后，获得的佣金比例" name="RATIO_ZT_1" v-model="RATIO_ZT_1" :limit="[0,50]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励，该奖励将从上级门店奖励中扣除"></c-form-item>
									<c-form-item v-if="item.id == 1" type="number" decimal="2" style="width:800px" label="推荐的平级星推官，推荐的会员下单后，获得的佣金比例" name="RATIO_JT_1" v-model="RATIO_JT_1" :limit="[0,50]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励，该奖励将从上级门店奖励中扣除"></c-form-item>
									<c-form-item v-if="item.id == 2" type="number" decimal="2" style="width:800px" label="直推会员下单后，获得的佣金比例" name="RATIO_ZT_2" v-model="RATIO_ZT_2" :limit="[0,80]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励"></c-form-item>
									<c-form-item v-if="item.id == 2" type="number" decimal="2" style="width:800px" label="推荐的平级门店会员下单后，获得的佣金比例" name="RATIO_JT_2" v-model="RATIO_JT_2" :limit="[0,50]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励，该奖励将从上级门店拓展奖励中扣除"></c-form-item>
									<c-form-item v-if="item.id == 3" type="number" decimal="2" style="width:800px" label="下属会员交易后，获得的默认佣金比例" name="RATIO_ZT_3" v-model="RATIO_ZT_3" :limit="[0,50]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励，此比例仅作为初始开通的分佣比例，具体比例以具体代理配置为准"></c-form-item>
									<c-form-item v-if="item.id == 3" type="number" decimal="2" style="width:800px" label="推荐的平级门店拓展下属会员下单后，获得的佣金比例" name="RATIO_JT_3" v-model="RATIO_JT_3" :limit="[0,50]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励，该奖励将从上级城市拓展奖励中扣除"></c-form-item>
									<c-form-item v-if="item.id == 4" type="number" decimal="2" style="width:800px" label="下属会员交易后，获得的佣金比例" name="RATIO_4" v-model="RATIO_4" :limit="[0,50]" input-unit="%" word="按交易金额抽取对应比例作为代理奖励"></c-form-item>
								</c-form>
								<c-form >
									<!-- <c-form-item v-model="item.is_directly_reward" type="radio" label="分享补贴" :options="directOptions" word="直推用户获得会员身份,可获得交易金额对应比例的『分享补贴』"></c-form-item>
									<c-form-item v-show="item.is_directly_reward == 2">
										<c-table v-model="item.directly_reward_list" border height="auto" style="width: 600px;">
											<c-table-column
												label="推荐等级"
												name="recommend_level_name"
											></c-table-column>
											<c-table-column
												label="奖励比例 (%)"
											>
												<template v-slot="{data}">
													<c-input v-model="data.reward_money" word="%"></c-input>
												</template>
											</c-table-column>
										</c-table>
									</c-form-item>
									
									<c-form-item v-model="item.is_indirect_reward" type="radio" label="辅助分享补贴" :options="indirectOptions" word="间推用户获得会员身份,可获得交易金额对应比例的『辅助分享补贴』"></c-form-item>
									<c-form-item v-show="item.is_indirect_reward == 2">
										<c-table v-model="item.indirect_reward_list" border height="auto" style="width: 600px;">
											<c-table-column
												label="间推等级"
												name="recommend_level_name"
											></c-table-column>
											<c-table-column
												label="奖励比例 (%)"
											>
												<template v-slot="{data}">
													<c-input v-model="data.reward_money" word="%"></c-input>
												</template>
											</c-table-column>
										</c-table>
									</c-form-item> -->
									
									<!-- <c-form-item v-model="item.is_zt_order_reward" type="radio" label="下单奖励" :options="directOptions" word="会员购买指定直销产品，分享用户可获得产品交易额对应比例的补贴奖励（有赠送会员时，不支持该奖励）"></c-form-item>
									<c-form-item v-show="item.is_zt_order_reward == 2" >
										<c-table v-model="item.zt_order_reward_list" border height="auto" style="width: 600px;">
											<c-table-column
												label="推荐等级"
												name="recommend_level_name"
											></c-table-column>
											<c-table-column
												label="奖励比例(%)"
											>
												<template v-slot="{data}">
													<c-input v-model="data.reward_money" :limit="[0,100]" word="%"></c-input>
												</template>
											</c-table-column>
										</c-table>
									</c-form-item>
									<c-form-item v-model="item.is_jt_order_reward" type="radio" label="辅助下单奖励" :options="indirectOptions" word="会员购买指定直销产品，辅导分享用户可获得产品交易额对应比例的补贴奖励（有赠送会员时，不支持该奖励）"></c-form-item>
									<c-form-item v-show="item.is_jt_order_reward == 2">
										<c-table v-model="item.jt_order_reward_list" border height="auto" style="width: 600px;">
											<c-table-column
												label="间推等级"
												name="recommend_level_name"
											></c-table-column>
											<c-table-column
												label="奖励比例(%)"
											>
												<template v-slot="{data}">
													<c-input v-model="data.reward_money" :limit="[0,100]" word="%"></c-input>
												</template>
											</c-table-column>
										</c-table>
									</c-form-item> -->
								</c-form>
								
								<!-- <c-form title="价差返佣设置">
									<c-form-item v-model="item.is_price_difference" type="radio" label="价差返佣" :options="commisionOptions" :inline-word="false">
										<div slot="word">
											<p>下级会员在商城下单，上级会员根据购买产品对应的『等级折扣的差价』享受『全额价差返佣』。</p>
											<p>例：A是下级(享受9折)，B是A的上级(享受8折)，当A在商城下单后，这中间的1折差价将全额奖励给B用户。</p>
										</div>
									</c-form-item>
								</c-form> -->
							</c-form>
						</div>
					</c-form-item>
				</c-form>
			</c-form>

			<template slot="button">
				<c-button size="m" @click="saveHandle()">提交保存</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import validate from '@/assets/script/validate.js'
	
	export default {
		name: 'm_share',
		
		data() {
			return {
				levelList: [],
				currentTab: 0,
				
				directOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				indirectOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				commisionOptions: [{
					name: '开启',
					value: 2
				}, {
					name: '关闭',
					value: 1
				}],
				
				RATIO_ZT_1: 0,
				RATIO_JT_1: 0,
				
				RATIO_ZT_2: 0,
				RATIO_JT_2: 0,
				
				RATIO_ZT_3: 0,
				RATIO_JT_3: 0,
				
				RATIO_4:0
			}
		},
		
		mounted() {
			this.request({
				url: '/share/config/detail',
				success: data => {
					data.zt_pz_order_ratio = data.zt_pz_order_ratio*100;
					data.jt_pz_order_ratio = data.jt_pz_order_ratio*100;
					
					this.RATIO_ZT_1 = ((data.RATIO_ZT_1||0)*100)+'';
					this.RATIO_JT_1 = ((data.RATIO_JT_1||0)*100)+'';
					this.RATIO_ZT_2 = ((data.RATIO_ZT_2||0)*100)+'';
					this.RATIO_JT_2 = ((data.RATIO_JT_2||0)*100)+'';
					this.RATIO_ZT_3 = ((data.RATIO_ZT_3||0)*100)+'';
					this.RATIO_JT_3 = ((data.RATIO_JT_3||0)*100)+'';
					
					this.RATIO_4 = ((data.RATIO_4||0)*100)+'';
					this.$refs.form.set(data);
					this.levelList = data.level_list;
				}
			});
		},

		methods: {
			saveHandle() {
				this.$refs.form.submit({
					url: '/share/config/edit',
					rule: {
						share_img_list: '请上传分销海报图',
                        auto_transfer_period: '请设置超期自动转单时间'
					},
					dataFormatter: data => {
						data.level_list = this.levelList;
						data.zt_pz_order_ratio = ""+(parseFloat(data.zt_pz_order_ratio)/100);
						data.jt_pz_order_ratio = ""+(parseFloat(data.jt_pz_order_ratio)/100);
						
						data.RATIO_ZT_1 = ""+(parseFloat(data.RATIO_ZT_1||0)/100);
						data.RATIO_JT_1 = ""+(parseFloat(data.RATIO_JT_1||0)/100);
						data.RATIO_ZT_2 = ""+(parseFloat(data.RATIO_ZT_2||0)/100);
						data.RATIO_JT_2 = ""+(parseFloat(data.RATIO_JT_2||0)/100);
						data.RATIO_ZT_3 = ""+(parseFloat(data.RATIO_ZT_3||0)/100);
						data.RATIO_JT_3 = ""+(parseFloat(data.RATIO_JT_3||0)/100);
						data.RATIO_4 = ""+(parseFloat(data.RATIO_4||0)/100);
						return data;
					},
					success: () => {
						this.$message({
							text: '保存设置成功', 
							icon: 'success'
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.tab {
		margin-bottom: -1px;

		li {
			width: 100px;
			border: 1px solid #ddd;
			padding: 0 10px;
			margin-right: -1px;
			line-height: 40px;
			font-size: 13px;
			text-align: center;
			color: #000;
			background: #fff;
			cursor: pointer;

			&:hover {
				position: relative;
			theme-border(lesser);
			theme-color(lesser);
			}

			&.z-crt {
				position: relative;
			theme-border(lesser);
				color: #fff;
			theme-background(lesser);
			}
		}
		
		&-content {
			border: 1px solid #ddd;
		}
	}
</style>